import {twMerge} from '../../../common/twMerge';
import {theme} from '../../../theme';
import {SingleImageBackground} from '../../molecules/BigBannerMobileCarousel/SingleImageBackground';
import {useRenderArrow} from '../../molecules/BigBannerMobileCarousel/useRenderArrow';
import {useRenderDots} from '../../molecules/BigBannerMobileCarousel/useRenderDots';
import {BigBannerMobileSwiperCarousel} from '../../molecules/BigBannerMobileSwiperCarousel/BigBannerMobileSwiperCarousel';
import {Carousel} from '../../molecules/Carousel/Carousel';
import {BigBannerProps} from './BigBannerProps.interface';

export function BigBanner({
  children,
  bgImage = '',
  hasSingleItem = false,
  hasIndicator = true,
  hasArrow = false,
  isAutoPlay = true,
  onChangeIndex,
  isMobile,
  isFoldable,
  isStorybook,
  isTopBanner,
  className,
  ...props
}: BigBannerProps) {
  const BigBannerCarousel =
    isMobile && !isFoldable && !isStorybook
      ? BigBannerMobileSwiperCarousel
      : Carousel;

  const onlyMobile = isMobile && !isFoldable;
  const onlyFoldable = isMobile && isFoldable;
  const onlyPc = !isMobile;

  const [renderNextArrow, renderPrevArrow] = useRenderArrow({
    isMobile,
    hasArrow,
  });
  const renderDots = useRenderDots({
    hasIndicator,
    isMobile,
  });

  return (
    <div
      className={twMerge(
        'relative',
        onlyPc && 'isolate overflow-hidden rounded-16pxr',
        onlyFoldable && hasSingleItem && 'overflow-hidden',
        className
      )}
      {...props}
    >
      {hasSingleItem && (onlyFoldable || onlyPc) && (
        <SingleImageBackground bgImage={bgImage} />
      )}
      <BigBannerCarousel
        className={twMerge('overflow-hidden', onlyPc && 'rounded-16pxr')}
        isInfinite
        autoInterval={DEFAULT_CAROUSEL_INTERVAL}
        isAutoPlay={isAutoPlay}
        onChangeIndex={onChangeIndex}
        gapPx={onlyMobile ? MOBILE_GAP : PC_FOLDABLE_GAP}
        renderDots={renderDots}
        responsive={
          isTopBanner
            ? {
                [Number(theme.screens['foldable'].replace('px', ''))]: {
                  isCenterMode: true,
                  centerPadding: isMobile ? '20%' : '25%',
                  gapPx: PC_FOLDABLE_GAP,
                },
              }
            : undefined
        }
        renderNextArrow={renderNextArrow}
        renderPrevArrow={renderPrevArrow}
      >
        {children}
      </BigBannerCarousel>
    </div>
  );
}

const DEFAULT_CAROUSEL_INTERVAL = 4000;
const MOBILE_GAP = 11;
const PC_FOLDABLE_GAP = 1.5;
